/**
 * Tracks whether a mobile-browser visitor has tapped "continue on web" past
 * the "Mobile Apps Coming Soon" interstitial (`MobileAppSplash`). Persisted in
 * localStorage so the notice shows once, not on every navigation or reload.
 *
 * Wrapped in try/catch because localStorage throws in private-mode Safari and
 * is absent in non-browser contexts — in that case the dismissal still works
 * for the current session (via in-memory state), it just won't persist.
 */
const STORAGE_KEY = 'ollie.mobileWebContinue';

export function hasContinuedOnWeb(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setContinuedOnWeb(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* storage unavailable — session-only dismissal still applies */
  }
}
